export default __webpack_public_path__ + "static/media/Partner Ad Working URL.6200984f.pdf";